import React from 'react';
import { graphql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FeedbackManagement.css';
import FeedbackManagementComponent from '../../../components/siteadmin/FeedbackManagement/FeedbackManagement';

class FeedbackManagement extends React.Component {
    render() {
        const { title } = this.props;
        return <FeedbackManagementComponent title={title} />;
    }
}

export default compose(
    withStyles(s),
)(FeedbackManagement);
